export interface PublicHoliday {
  date: string;
  name: string;
  country: "Moldova" | "USA";
}

export const PUBLIC_HOLIDAYS: PublicHoliday[] = [
  // Moldova 2025
  { date: "2025-01-01", name: "New Year’s Day", country: "Moldova" },
  { date: "2025-01-07", name: "Orthodox Christmas", country: "Moldova" },
  { date: "2025-01-08", name: "Orthodox Christmas", country: "Moldova" },
  { date: "2025-03-08", name: "International Women’s Day", country: "Moldova" },
  { date: "2025-04-20", name: "Orthodox Easter", country: "Moldova" },
  { date: "2025-04-21", name: "Orthodox Easter Monday", country: "Moldova" },
  { date: "2025-04-28", name: "Memorial/Parents’ Day", country: "Moldova" },
  { date: "2025-05-01", name: "Labor Day", country: "Moldova" },
  { date: "2025-05-09", name: "Victory and Europe Day", country: "Moldova" },
  {
    date: "2025-06-01",
    name: "International Children’s Day",
    country: "Moldova",
  },
  { date: "2025-08-27", name: "Independence Day", country: "Moldova" },
  { date: "2025-08-31", name: "National Language Day", country: "Moldova" },
  {
    date: "2025-10-14",
    name: "Local Patron Saint Day (Hram)",
    country: "Moldova",
  },
  { date: "2025-12-25", name: "Western Christmas", country: "Moldova" },

  // Moldova 2026
  { date: "2026-01-01", name: "New Year’s Day", country: "Moldova" },
  { date: "2026-01-07", name: "Orthodox Christmas", country: "Moldova" },
  { date: "2026-01-08", name: "Orthodox Christmas", country: "Moldova" },
  { date: "2026-03-08", name: "International Women’s Day", country: "Moldova" },
  { date: "2026-04-12", name: "Orthodox Easter", country: "Moldova" },
  { date: "2026-04-13", name: "Orthodox Easter Monday", country: "Moldova" },
  { date: "2026-04-20", name: "Memorial/Parents’ Day", country: "Moldova" },
  { date: "2026-05-01", name: "Labor Day", country: "Moldova" },
  { date: "2026-05-09", name: "Victory and Europe Day", country: "Moldova" },
  {
    date: "2026-06-01",
    name: "International Children’s Day",
    country: "Moldova",
  },
  { date: "2026-08-27", name: "Independence Day", country: "Moldova" },
  { date: "2026-08-31", name: "National Language Day", country: "Moldova" },
  {
    date: "2026-10-14",
    name: "Local Patron Saint Day (Hram)",
    country: "Moldova",
  },
  { date: "2026-12-25", name: "Western Christmas", country: "Moldova" },

  // USA 2025
  { date: "2025-01-01", name: "New Year’s Day", country: "USA" },
  { date: "2025-05-26", name: "Memorial Day", country: "USA" },
  { date: "2025-07-04", name: "Independence Day", country: "USA" },
  { date: "2025-09-01", name: "Labor Day", country: "USA" },
  { date: "2025-11-27", name: "Thanksgiving Day", country: "USA" },
  { date: "2025-12-25", name: "Christmas Day", country: "USA" },

  // USA 2026
  { date: "2026-01-01", name: "New Year’s Day", country: "USA" },
  { date: "2026-05-25", name: "Memorial Day", country: "USA" },
  { date: "2026-07-04", name: "Independence Day", country: "USA" },
  { date: "2026-09-07", name: "Labor Day", country: "USA" },
  { date: "2026-11-26", name: "Thanksgiving Day", country: "USA" },
  { date: "2026-12-25", name: "Christmas Day", country: "USA" },
];

export const MOLDOVA_PUBLIC_HOLIDAYS = PUBLIC_HOLIDAYS.filter(
  (h) => h.country === "Moldova"
);

export const USA_PUBLIC_HOLIDAYS = PUBLIC_HOLIDAYS.filter(
  (h) => h.country === "USA"
);
